import { Button } from '@progress/kendo-react-buttons';
import PropTypes from 'prop-types';
import React from 'react';

export default function FormFooterWithAccess(props) {
  return (
    <div style={{ marginBottom: '2vh' }}>
      <div className="k-form-buttons">
        <Button
          type={'submit'}
          disabled={!props.formRenderProps.allowSubmit}
          className="blueButton"
        >
          Enregistrer
        </Button>

        <Button
          onClick={props.formRenderProps.onFormReset}
          className="whiteButton"
        >
          Réinitialiser
        </Button>
        {props.selectedRow && <>{props.showAddButton && (<span className='blueButton k-icon k-font-icon k-i-plus' style={{ cursor: 'pointer' }} title="Ajouter une demande de produits" onClick={() => { props.setDataForm(props.selectedRow); props.setSelectedRow(undefined); }} />)}
          <div style={{ position: 'absolute', marginRight: '10px', right: 0 }}>
            <Button
              style={{
                margin: '2px',
                borderRadius: '50%',
                width: '34px',
                height: '34px',
                marginLeft: 'auto',
              }}
              icon={'trash'}
              title={'Supprimer'}
              className="redButton"
              onClick={() => {
                props.delete();
              }}
            ></Button>
          </div></>
        }
      </div>
    </div>
  );
}

FormFooterWithAccess.propTypes = {
  delete: PropTypes.func,
  formRenderProps: PropTypes.any,
  selectedRow: PropTypes.any,
  gridData: PropTypes.any,
  documents: PropTypes.any,
  showAddButton: PropTypes.bool,
  setSelectedRow: PropTypes.any,
  setDataForm: PropTypes.func
};
